// Ví PRO (theo TỪNG SITE) + Points (chung ebook/pmaker). eng/lab chỉ PRO.
import { API_CONFIG } from '../../config/api.config'

const API = API_CONFIG.python.apiUrl
const tk = () => localStorage.getItem('jwt_token') || localStorage.getItem('auth_token') || localStorage.getItem('token') || ''

async function req<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${API}${path}`, {
    ...init,
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${tk()}`, ...(init?.headers || {}) },
  })
  if (!res.ok) {
    const d = await res.json().catch(() => ({}))
    throw new Error(d.detail || `HTTP ${res.status}`)
  }
  return res.json()
}

export type SiteKey = 'ebook' | 'eng' | 'lab'
export interface SitePro { enabled: boolean; active: boolean; tier: string | null; expires_at: string | null; days_left: number }
export interface MembershipMe {
  sites: Record<SiteKey, SitePro>; points: number; role: string; email?: string
  wallet_balance?: number; allowance_remaining?: number; monthly_allowance?: number; allowance_reset_at?: string | null
}
export interface BankInfo { bank_id: string; account: string; account_name: string }
export interface AdminUserRow {
  id: string; email: string; name: string; role: string; source_domain?: string
  sites: Record<SiteKey, SitePro>; points: number   // points = ví mua thêm
  allowance_remaining?: number; monthly_allowance?: number   // hạn mức tháng (PRO)
}

export const membershipService = {
  me: () => req<MembershipMe>('/membership/me'),
  prices: () => req<{ unit_vnd: number; prices: Record<string, number>; packages: any[]; starter: number; pro_price_vnd?: number; pro_monthly_points?: number; bank?: BankInfo | null; zalo?: string }>('/points/prices'),
  transactions: (limit = 50) => req<any[]>(`/points/transactions?limit=${limit}`),
  topupRequest: (amount_vnd: number) => req<any>('/points/topup-request', { method: 'POST', body: JSON.stringify({ amount_vnd }) }),

  // Admin
  adminUsers: (search = '', site = '', role = '', limit = 300, offset = 0) =>
    req<AdminUserRow[]>(`/membership/admin/users?search=${encodeURIComponent(search)}&site=${encodeURIComponent(site)}&role=${encodeURIComponent(role)}&limit=${limit}&offset=${offset}`),
  setSitePro: (user_id: string, site: SiteKey, tier: 'off' | 'trial' | 'pro') =>
    req<any>('/membership/admin/site-pro', { method: 'POST', body: JSON.stringify({ user_id, site, tier }) }),
  adjustPoints: (user_id: string, points: number, note?: string) =>
    req<any>('/membership/admin/points', { method: 'POST', body: JSON.stringify({ user_id, points, note }) }),
}
